module.exports = __webpack_public_path__ + "img/step1-2.6234b9a8.png";